import React, { useState, useEffect } from 'react'
import * as SearchAddressStyles from '../styles/search.module.scss'
import { Row, Col } from 'react-bootstrap'

import { navigate } from 'gatsby'

const Search = (props) => {
  const [txToSearch, setTxToSearch] = useState('')
  const [inFetch, setInFetch] = useState(false)

  const { txid, onSearch } = props

  useEffect(() => {
    const searchToken = () => {
      if (txid) {
        setInFetch(true)
        onSearch(txid)
        setTxToSearch(txid)
      }
    }
    if (!inFetch) {
      searchToken()
    }
  })

  const handleInput = () => {
    navigate(`?txid=${txToSearch}`)
    onSearch(txToSearch)
  }
  const handleKeyDown = (e) => {
    try {
      if (e.key === 'Enter') {
        navigate(`?txid=${txToSearch}`)
        onSearch(txToSearch)
      }
    } catch (error) {
      console.warn(error)
    }
  }

  return (
    <Row className={SearchAddressStyles.wrapper}>
      <Col xs={9} md={6}>
        <input
          value={txToSearch}
          className={SearchAddressStyles.searchInput}
          type='text'
          placeholder='Search Transaction'
          onChange={e => setTxToSearch(e.target.value)}
          onKeyDown={handleKeyDown}
        />

      </Col>
      <Col xs={3} md={1}>
        <button className={SearchAddressStyles.loadBtn} onClick={handleInput} onKeyDown={handleKeyDown}>Load</button>

      </Col>
    </Row>
  )
}

export default Search
